// Phone number formatting utilities

export const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return '';
  
  // Handle extensions - look for common extension patterns
  const extensionPatterns = [
    /(.+)\s+ext\.?\s*(\d+)/i,
    /(.+)\s+extension\s+(\d+)/i,
    /(.+)\s+x(\d+)/i,
    /(.+)\s+#(\d+)/i
  ];
  
  let mainNumber = phoneNumber;
  let extension = '';
  
  // Check for extension patterns
  for (const pattern of extensionPatterns) {
    const match = phoneNumber.match(pattern);
    if (match) {
      mainNumber = match[1].trim();
      extension = match[2];
      break;
    }
  }
  
  // Remove all non-digits from main number
  const cleaned = mainNumber.replace(/\D/g, '');
  
  let formatted = '';
  
  // Format based on length
  if (cleaned.length === 10) {
    // Format as XXX.XXX.XXXX
    formatted = `${cleaned.slice(0, 3)}.${cleaned.slice(3, 6)}.${cleaned.slice(6)}`;
  } else if (cleaned.length === 11 && cleaned.startsWith('1')) {
    // Format as 1.XXX.XXX.XXXX
    formatted = `${cleaned.slice(0, 1)}.${cleaned.slice(1, 4)}.${cleaned.slice(4, 7)}.${cleaned.slice(7)}`;
  } else {
    // Return cleaned number if not standard format
    formatted = cleaned;
  }
  
  // Add extension if present
  if (extension) {
    formatted += ` ext ${extension}`;
  }
  
  return formatted || phoneNumber;
};

// Allow only digits and dots in phone input
export const cleanPhoneInput = (input) => {
  return input.replace(/[^\d.]/g, '');
};

export default { formatPhoneNumber, cleanPhoneInput };
